module.exports = __webpack_public_path__ + "static/media/isb.c471be0b.png";